import React, { memo } from 'react';
import { di } from 'react-magnetic-di';
import { FieldBusyIndicator } from '@atlassian/ui-modifications-core';
import { useFieldIsBusy } from '@atlassian/ui-modifications-core/controllers';
import type { EnabledFieldDecoratorProps } from './types';

const EnabledFieldDecoratorNoMemo = ({ Component, componentProps }: EnabledFieldDecoratorProps) => {
	di(useFieldIsBusy, FieldBusyIndicator);
	const { id } = componentProps;

	const isBusy = useFieldIsBusy(id as string);

	return (
		<Component
			{...componentProps}
			// disabled for summary field
			// isDisabled for other fields
			{...(isBusy
				? { disabled: true, isDisabled: true, tooltip: <FieldBusyIndicator fieldId={id} /> }
				: {})}
		/>
	);
};
export const EnabledFieldDecorator = memo(EnabledFieldDecoratorNoMemo);
